import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { BOOKS } from "../data/site";

export default function Books() {
    return (
        <div data-testid="books-page" className="pb-28">
            <PageHeader
                testid="books-header"
                breadcrumb="Books & Profiles"
                title="The therapy room shelf"
                number="02"
                label="Books & Profiles"
                heading="Stories from the therapy room shelf"
            >
                <p className="mt-5 max-w-2xl text-base leading-relaxed text-amber-100/70">
                    Dora writes the books she wished existed in the therapy room
                    — gentle stories that give children words for big feelings,
                    and grown-ups a way in. Our therapists write, too.
                </p>

                <div className="mt-12 grid gap-6 md:grid-cols-3">
                    {BOOKS.map((b, i) => (
                        <motion.div
                            key={b.title}
                            data-testid={`book-card-${i}`}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            className="flex flex-col overflow-hidden rounded-2xl border border-amber-500/15 bg-[#1F1510]/50"
                        >
                            <div className="flex aspect-[4/5] w-full items-center justify-center overflow-hidden bg-gradient-to-b from-[#f6ecda] to-[#e7d8bd] p-5">
                                <img
                                    src={`/images/${b.img}`}
                                    alt={`Cover of ${b.title}`}
                                    className="max-h-full max-w-full rounded-md object-contain shadow-[0_10px_30px_rgba(0,0,0,0.35)] transition-transform duration-500 hover:scale-[1.04]"
                                />
                            </div>
                            <div className="flex flex-1 flex-col p-6">
                                <span className="text-xs uppercase tracking-[0.2em] text-amber-400/80">
                                    {b.tag}
                                </span>
                                <h3 className="mt-3 font-serif text-xl leading-snug text-amber-100">
                                    {b.title}
                                </h3>
                                {b.author && (
                                    <p className="mt-2 text-xs leading-relaxed text-amber-200/60">
                                        {b.author}
                                    </p>
                                )}
                                <p className="mt-3 flex-1 text-sm leading-relaxed text-amber-100/60">
                                    {b.body}
                                </p>
                                <a
                                    href={b.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-300 hover:text-amber-200"
                                >
                                    Find it on Amazon
                                    <ArrowUpRight className="h-4 w-4" />
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-12">
                    <a
                        href="https://www.amazon.com/Dora-Henderson/e/B0C2PFMJK5"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 rounded-full border border-amber-500/40 px-7 py-3.5 text-sm font-semibold text-amber-100 transition-colors hover:border-amber-400 hover:bg-amber-500/10"
                    >
                        Browse Dora's full shelf on Amazon
                        <ArrowUpRight className="h-4 w-4" />
                    </a>
                </div>
            </PageHeader>
        </div>
    );
}
